const modules = {
    INSTRUCTIONS: 'education',
    MEASURES: 'provision',
    CONSTRUCTION_SITES: 'egb',
    ARCHIVE: 'archive',
    NEW_RISK_ASSESSMENT: 'new_risk_assessment',
};

export default modules;
